import { enUS, ru } from 'date-fns/locale';
import { Locale } from 'date-fns';
import { UnderscoreLocale, I18nextLocale } from './types';

const DATE_FNS_EN = enUS;
const DATE_FNS_RU = ru;

export const LOCAL_STORAGE_LANGUAGE_KEY = 'language';
export const UNDERSCORE_EN = 'en_US';
export const UNDERSCORE_RU = 'ru_RU';
export const I18NEXT_EN = 'en';
export const I18NEXT_RU = 'ru';

export const UNDERSCORE_TO_I18NEXT_LOCALE = new Map<UnderscoreLocale, I18nextLocale>([
  [UNDERSCORE_EN, I18NEXT_EN],
  [UNDERSCORE_RU, I18NEXT_RU],
]);

export const I18NEXT_TO_DATE_FNS_LOCALE = new Map<I18nextLocale, Locale>([
  [I18NEXT_EN, DATE_FNS_EN],
  [I18NEXT_RU, DATE_FNS_RU],
]);
